export default "__VITE_ASSET__2dc97f73__"